module.exports = __webpack_public_path__ + "img/SingleLine.7411cc6c.svg";